export default __webpack_public_path__ + "static/media/CCS Information Brochure.7632fe73.pdf";